import { render } from "./payTypeJump.vue?vue&type=template&id=212f2f5a&scoped=true"
import script from "./payTypeJump.vue?vue&type=script&lang=js"
export * from "./payTypeJump.vue?vue&type=script&lang=js"

import "./payTypeJump.vue?vue&type=style&index=0&id=212f2f5a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-212f2f5a"

export default script